import { render } from "./DiscountNodeLabel.vue?vue&type=template&id=6f0d25f6&scoped=true"
import script from "./DiscountNodeLabel.vue?vue&type=script&lang=js"
export * from "./DiscountNodeLabel.vue?vue&type=script&lang=js"

import "./DiscountNodeLabel.vue?vue&type=style&index=0&id=6f0d25f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0d25f6"]])

export default __exports__